import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {useTranslation} from '@/translations/i18n'
import {Controller, useFormContext} from 'react-hook-form'
import {UserProfessionalInsuranceFormValidationSchema} from '@/features/users/types'
import {StyledGridItem} from './style'
import {InputSelectMonthYear} from '@/components/commons/input-select-month-year/InputSelectMonthYear'

export const UserProfessionalInsuranceForm = () => {
    const {t} = useTranslation()

    // methods
    const form = useFormContext<UserProfessionalInsuranceFormValidationSchema>()

    return (
        <Grid columns={6} fullWidth>
            <StyledGridItem>
                <Controller
                    control={form.control}
                    name="professionalInsuranceLastVerify"
                    render={({field}) => (
                        <InputSelectMonthYear
                            label={t('users:month_year_expiration')}
                            onChange={field.onChange}
                            value={field.value ?? null}
                            errorMessage={form.formState.errors.professionalInsuranceLastVerify?.message}
                        />
                    )}
                />
            </StyledGridItem>
        </Grid>
    )
}
